import React, { useEffect } from 'react';

export default function ScrollDirection({ setDirection }) {
  useEffect(() => {
    let scrollPos = 0;
    const handleScroll = () => {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      if (st < 160) {
        scrollPos = st <= 0 ? 0 : st;
        setDirection('up');
        return scrollPos;
      }
      if (st > scrollPos) {
        setDirection('down');
      } else {
        setDirection('up');
      }
      scrollPos = st <= 0 ? 0 : st;
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return null;
}
